import request from './base'

export const getMapList = (params) => {
    return request.post("/merchant/v1/map/list", params)
}
export const getMapInfo = (params) => {
    return request.post("/merchant/v1/map/info", params)
}
export const getMapInfo2 = (params) => {
    return request.post("/merchant/v1/map/info2", params)
}
export const mapModify = (params) => {
    return request.post("/merchant/v1/map/modify", params)
}
export const getMapSelect = () => {
    return request.post("/merchant/v1/map/select")
}
export const mapPoiAdd = (params) => {
    return request.post("/merchant/v1/map/poi/add", params)
}
export const mapPoiModify = (params) => {
    return request.post("/merchant/v1/map/poi/modify", params)
}
export const mapPoiDelete = (params) => {
    return request.post("/merchant/v1/map/poi/delete", params)
}
export const mapPushLogs = (params) => {
    return request.post("/merchant/v1/map/pushLogs", params)
}
export const getMapCarList = (params) => {
    return request.post("/merchant/v1/map/carList", params)
}
export const mapPush = (params) => {
    return request.post("/merchant/v1/map/push", params)
}
export const createMapImage = (params) => {
    return request.post("/merchant/v1/map/createMapImage", params)
}
export const regionList = () => {
    return request.post("/merchant/v1/map/regionList")
}


// WEBPACK FOOTER //
// ./src/api/map.js